const focusedElementBeforeMenu: HTMLElement|null = null
const menus = document.querySelectorAll( '[data-menu]' ) as NodeListOf<HTMLElement>
const menuOverlay = document.querySelector( '.modal-overlay' ) as HTMLElement
const menuToggles = document.querySelectorAll( '[data-open-menu]' ) as NodeListOf<HTMLElement>

export { focusedElementBeforeMenu, menus, menuOverlay, menuToggles }
